import React from "react";

const WidgetToolbar = ({ style }) => {
  return (
    <div
      style={{ ...DEFAULT_STYLE, ...style }}
      className={"widget-toolbar-r"}
    ></div>
  );
};

const DEFAULT_STYLE = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "36px",
  lineHeight: "36px",
  background: "rgba(245, 245, 245, 1)",
  borderBottom: "1px solid #C8C8C8",
  pointerEvents: "none",
  paddingLeft: "1em",
  boxShadow: "0px 0px 0px 0px rgba(0, 0, 0, 0)",
};

export default WidgetToolbar;
